import axios from "../../../../utils/axios-private";

export const getBuildingTypes = () => {
  return {
    type: "GET_DROPDOWN_BUILDING_TYPES",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/databasic/jenisbangunan`;
      axios
        .get(url, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
